export default "__VITE_ASSET__Jkr89UoA__"